import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "content-shape container pt-4"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("My messages");

import { ref, reactive, computed } from "vue";
import { orderBy } from "lodash";
import { DateTime } from "luxon";
import { useLoadingBar } from "naive-ui";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { handleError } from "@/utils/errors";
import MessagesList from "@/components/messages/MessagesList.vue";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var loadingBar = useLoadingBar();
    var loaders = reactive({
      fetch: LoaderStateEnum.Idle
    });
    var errors = reactive({});
    var messages = ref([]);
    var sorted = computed(function () {
      return orderBy(messages.value, function (m) {
        return DateTime.fromISO(m.creationDate, {
          zone: "UTC"
        }).toMillis();
      }, "desc");
    });

    var load = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loadingBar.start();
                loaders.fetch = LoaderStateEnum.Loading;
                _context.prev = 2;
                _context.next = 5;
                return http.get("/users/messages");

              case 5:
                response = _context.sent;
                messages.value = response.data;
                loaders.fetch = LoaderStateEnum.Loaded;
                loadingBar.finish();
                _context.next = 18;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                _context.next = 15;
                return handleError(_context.t0, {
                  placeholder: "The requested data is currently inaccessible."
                });

              case 15:
                errors.fetch = _context.sent;
                loaders.fetch = LoaderStateEnum.Failed;
                loadingBar.error();

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 11]]);
      }));

      return function load() {
        return _ref.apply(this, arguments);
      };
    }();

    load();
    return function (_ctx, _cache) {
      var _component_n_h1 = _resolveComponent("n-h1");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_h1, null, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }), _createVNode(MessagesList, {
        messages: _unref(sorted),
        loader: _unref(loaders).fetch,
        error: _unref(errors).fetch,
        onRetry: _cache[0] || (_cache[0] = function ($event) {
          return load();
        })
      }, null, 8, ["messages", "loader", "error"])]);
    };
  }
});